var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"carousel mb-0 bg-[url('https://a.storyblok.com/f/118728/400x88/c9b0180ca4/perkotaan.png/m/400x88/')] bg-repeat",attrs:{"id":"carousel"}},[(_vm.story.content.component)?_c(_vm.story.content.component,{key:_vm.story.content._uid,tag:"component",attrs:{"blok":_vm.story.content}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }